<script lang="ts">
  import LaunchpadIndex from './LaunchpadIndex.svelte'
  import LaunchpadGotContacts from './LaunchpadGotContacts.svelte'
  import LaunchpadGotNoContacts from './LaunchpadGotNoContacts.svelte'
  import LaunchpadAutoResponse from './LaunchpadAutoResponse.svelte'
  import Modal from '../shared/modals/Modal.svelte'
  import { fade } from 'svelte/transition'
  import { state, setLaunchpadShown, setCurrentView } from '../../stores/launchpad.svelte'

  let currentView = $derived(state.currentView)

  let isIndex = $derived(currentView === 'index')

  function onClose() {
    setLaunchpadShown()
    currentView = 'index'
    document.querySelector('body').classList.remove('launchpad-modal-active')
  }

  function onShow() {
    document.querySelector('body').classList.add('launchpad-modal-active')
  }

  function shouldShowCard(type) {
    return currentView === type
  }

  function setView(e, type) {
    e.preventDefault()
    setCurrentView(type)
  }

  function fadeIn(node, { view }) {
    if (view === currentView) {
      return fade(node)
    }
  }
</script>

<Modal
  id="launchpad-modal"
  class="LaunchpadModal"
  show={state.isFirstRun}
  {onShow}
  {onClose}
>
  {#snippet trigger(toggle)}
    <button class="btn btn-link no-padding" onclick={toggle}>
      <span class="icon icon--launchpad-rocket ttip-item">
        <span class="ttip ttip--green ttip--left">
          <span class="p">SHOW THE LAUNCHPAD</span>
        </span>
      </span>
    </button>
  {/snippet}

  {#snippet content()}
    <div class="launchpad-modal-content">
      <div class="launchpad-top-nav" class:shadowed={!isIndex}>

        <div class="launchpad-title pull-left">
          <span class="icon icon--launchpad-rocket" class:d-none={!isIndex}></span>
          Launchpad
        </div>

        <ul class="nav navbar-nav pull-right" class:d-none={isIndex}>
          <li>
            <a href="."
               class:active={shouldShowCard('got-contacts')}
               onclick={(e) => setView(e, 'got-contacts')}>Got Contacts</a>
          </li>
          <li>
            <a href="."
               class:active={shouldShowCard('got-no-contacts')}
               onclick={(e) => setView(e, 'got-no-contacts')}>Got No Contacts</a>
          </li>
          <li>
            <a href="."
               class:active={shouldShowCard('auto-response')}
               onclick={(e) => setView(e, 'auto-response')}>Auto Response</a>
          </li>
          {#if false}
            <li>
              <a href="."
                 class:active={shouldShowCard('tour')}
                 onclick={(e) => setView(e, 'tour')}>Want a Tour?</a>
            </li>
          {/if}
        </ul>

        <div style="clear:both;"></div>
      </div>

      {#if shouldShowCard('index')}
        <div transition:fadeIn={{ view: 'index' }}>
          <LaunchpadIndex></LaunchpadIndex>
        </div>
      {/if}
      {#if shouldShowCard('got-contacts')}
        <div transition:fadeIn={{ view: 'got-contacts' }}>
          <LaunchpadGotContacts></LaunchpadGotContacts>
        </div>
      {/if}
      {#if shouldShowCard('got-no-contacts')}
        <div transition:fadeIn={{ view: 'got-no-contacts' }}>
          <LaunchpadGotNoContacts></LaunchpadGotNoContacts>
        </div>
      {/if}
      {#if shouldShowCard('auto-response')}
        <div transition:fadeIn={{ view: 'auto-response' }}>
          <LaunchpadAutoResponse></LaunchpadAutoResponse>
        </div>
      {/if}

      {#if false}
        <div transition:fadeIn={{ view: 'tour' }}>
          <!--          <launchpad-tour></launchpad-tour>-->
        </div>
      {/if}
    </div>
  {/snippet}

</Modal>
